import { useEffect, useState } from "react";
import { User } from "@supabase/supabase-js";
import { supabase } from "@/integrations/supabase/client";

const ROLE_TO_COLUMN: Record<string, string> = {
  "Director": "sm_edit_project__project_director",
  "Manager": "sm_edit_project__project_manager",
};

export const useScheduleEditProjectAccess = (user: User | null) => {
  const [canEditProject, setCanEditProject] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const run = async () => {
      if (!user?.email) {
        setLoading(false);
        return;
      }
      try {
        setLoading(true);
        const { data: userRow } = await supabase
          .from("users")
          .select("role, company_name")
          .eq("email", user.email)
          .maybeSingle();

        const role = userRow?.role ?? null;
        const companyName = userRow?.company_name ?? null;
        const column = role ? ROLE_TO_COLUMN[role] : undefined;

        if (!column || !companyName) {
          setCanEditProject(true);
          return;
        }

        const { data: permRow } = await supabase
          .from("project_access_permissions")
          .select(column)
          .eq("company_name", companyName)
          .maybeSingle();

        if (!permRow) {
          setCanEditProject(true);
          return;
        }

        const value = (permRow as unknown as Record<string, unknown>)[column];
        setCanEditProject(value !== false);
      } catch (e) {
        console.error("useScheduleEditProjectAccess error", e);
        setCanEditProject(true);
      } finally {
        setLoading(false);
      }
    };
    run();
  }, [user?.email]);

  return { canEditProject, loading };
};
